var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemove = function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 5.25h1v6h-1zM7.625 5.25h1v6h-1zM5.625 5.25h1v6h-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 2.188h-2.27L8.613.655C8.395.301 7.903 0 7.493 0H4.73c-.41 0-.902.3-1.12.656l-.93 1.531H.437A.45.45 0 0 0 0 2.626v.438c0 .246.191.437.438.437h.437l.574 9.27c.028.683.63 1.23 1.313 1.23H9.46c.684 0 1.285-.547 1.312-1.23l.602-9.27h.438a.45.45 0 0 0 .437-.438v-.437a.47.47 0 0 0-.438-.438ZM4.73 1.312h2.762l.52.875H4.21l.52-.874Zm4.73 11.376H2.763L2.187 3.5h7.848l-.574 9.188Z"
  })));
};
export default SvgRemove;